import { handleUnknownError } from '@news-mono/common'
import { Logger } from 'typescript-log'
import { OEmbedResult } from './oembed'

const EMBEDLY_API_KEY = '2ac17161f707456d853e010bafc56489'

export async function loadEmbedlyData(link: string, log: Logger) {
    // If we don't have a placeholder we need to worry about the
    // position of the iframe in relationship to the top of the page.

    // The Embedly API fails as the referer "about:blank" is rejected by Embedly
    // Using curl does work so I captured sample embedly json

    /*
    // Sample Embedly response obtained using curl
        const embedlyResponse = {
        provider_url: 'https://www.youtube.com/',
        description: 'First with the news, when you need to see it.',
        title: 'Make the switch to 7 News',
        url: 'http://www.youtube.com/watch?v=pv8um_t-KJE',
        author_name: '7NEWS',
        height: 250,
        thumbnail_width: 480,
        width: 300,
        html: '<iframe class="embedly-embed" src="https://cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fwww.youtube.com%2Fembed%2Fpv8um_t-KJE%3Ffeature%3Doembed&url=http%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3Dpv8um_t-KJE&image=https%3A%2F%2Fi.ytimg.com%2Fvi%2Fpv8um_t-KJE%2Fhqdefault.jpg&key=78a880887ae04cad8ee514b60b53177f&type=text%2Fhtml&schema=youtube" width="300" height="250" scrolling="no" frameborder="0" allowfullscreen></iframe>',
        author_url: 'https://www.youtube.com/user/7NEWS',
        version: '1.0',
        provider_name: 'YouTube',
        thumbnail_url: 'https://i.ytimg.com/vi/pv8um_t-KJE/hqdefault.jpg',
        type: 'video',
        thumbnail_height: 360,

    */
    const api = 'https://api.embedly.com/1/oembed?'
    const encodedUrl = encodeURIComponent(link)
    const params = `url=${encodedUrl}&key=${EMBEDLY_API_KEY}&scheme=https`

    try {
        const embedlyResult = await fetch(`${api}${params}`)
        if (embedlyResult.status !== 200) {
            log.warn(
                { status: embedlyResult.status, link },
                `Embedly call failed`,
            )
            return undefined
        }
        return (await embedlyResult.json()) as OEmbedResult
    } catch (error) {
        const err = handleUnknownError(error)
        log.error({ api, params, link, err }, `Embedly call failed`)
        return undefined
    }
}

// returns an id based on the embed and its link - used for data loading
export function getEmbedId(link: string) {
    return `embed-${link}`
}
